import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles'; // Import styled
import {
  LocationOn,
  Phone,
  Email,
  Twitter,
  Facebook,
  YouTube,
  Instagram,
  LinkedIn,
} from '@mui/icons-material';


const Footer = () => {
  const StyledRouterLink = styled(RouterLink)(({ theme }) => ({
    color: '#F3F6F8',
    textDecoration: 'none', 
  }));
  return (
    <Box
      sx={{
        backgroundColor: '#91f086',
        color: '#F3F6F8', // Light text color
        marginTop: '6rem',
        paddingTop: '3rem',
        paddingBottom: '2rem',
      }}
    >
      <Container>
        <Grid container spacing={5}>
          {/* Get In Touch */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h5" sx={{ color: '#000', marginBottom: 2, fontSize: '23px' }}>
              Get In Touch
            </Typography>
            <Link
              href="https://www.google.com/maps/place/FasturaTechnologies/@9.924109,78.1445669,17z/data=!3m1!4b1!4m6!3m5!1s0x3bae10e042e1b15f:0xd20059cfd0695fe3!8m2!3d9.9241037!4d78.1471418!16s%2Fg%2F11cn3h940j?entry=ttu&g_ep=EgoyMDI1MDEwMi4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 1,
                color: '#000',
                textDecoration: 'none',
              }}
            >
              <LocationOn sx={{ marginRight: 1 }} />
              #311, 1st East Main Road, Sathamangalam, Anna Nagar, Madurai, Tamil Nadu 625020.
            </Link>
            <Link
              href="tel:+919042068861"
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 1,
                color: '#000',
                textDecoration: 'none',
              }}
            >
              <Phone sx={{ marginRight: 1 }} />
              +91 9042068861
            </Link>
            <Link
              href="mailto:contact@finkoda.com"
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 1,
                color: '#000',
                textDecoration: 'none',
              }}
            >
              <Email sx={{ marginRight: 1 }} />
              contact@finkoda.com
            </Link>
            <Box sx={{ display: 'flex', gap: 1, marginTop: 2 }}>
              <IconButton
                aria-label="Twitter Profile"
                href="https://x.com/Finkodaoffl"
                target="_blank"
                sx={{
                  color: '#000',
                  border: '1px solid rgba(256, 256, 256, .1)',
                  borderRadius: '40px',
                  padding: 1,
                  transition: '.3s',
                  '&:hover': {
                    color: '#00A9E0', // Customize hover color (primary)
                  },
                }}
              >
                <Twitter />
              </IconButton>
              <IconButton
                aria-label="Facebook Profile"
                href="https://www.facebook.com/finkodaofficial/"
                target="_blank"
                sx={{
                  color: '#000',
                  border: '1px solid rgba(256, 256, 256, .1)',
                  borderRadius: '40px',
                  padding: 1,
                  transition: '.3s',
                  '&:hover': {
                    color: '#3b5998', // Facebook hover color
                  },
                }}
              >
                <Facebook />
              </IconButton>
              <IconButton
                aria-label="Youtube Channel"
                href="https://www.youtube.com/@Finkoda"
                target="_blank"
                sx={{
                  color: '#000',
                  border: '1px solid rgba(256, 256, 256, .1)',
                  borderRadius: '40px',
                  padding: 1,
                  transition: '.3s',
                  '&:hover': {
                    color: '#FF0000', // YouTube hover color
                  },
                }}
              >
                <YouTube />
              </IconButton>
              <IconButton
                aria-label="Instagram Profile"
                href="https://www.instagram.com/finkodaoffl/"
                target="_blank"
                sx={{
                  color: '#000',
                  border: '1px solid rgba(256, 256, 256, .1)',
                  borderRadius: '40px',
                  padding: 1,
                  transition: '.3s',
                  '&:hover': {
                    color: '#E4405F', // Instagram hover color
                  },
                }}
              >
                <Instagram />
              </IconButton>
              <IconButton
                aria-label="Linkedin Profile"
                href="https://www.linkedin.com/in/finkoda/"
                target="_blank"
                sx={{
                  color: '#000',
                  border: '1px solid rgba(256, 256, 256, .1)',
                  borderRadius: '40px',
                  padding: 1,
                  transition: '.3s',
                  '&:hover': {
                    color: '#0077b5', // LinkedIn hover color
                  },
                }}
              >
                <LinkedIn />
              </IconButton>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h5" sx={{ color: '#000', marginBottom: 2, fontSize: '23px' }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, }}>
              <StyledRouterLink to="/about" sx={{ color: '#000' }}>About Us</StyledRouterLink>
              <StyledRouterLink to="/contact" sx={{ color: '#000' }}>Contact Us</StyledRouterLink>
              <StyledRouterLink to="/information" sx={{ color: '#000' }}>Information</StyledRouterLink>
              <StyledRouterLink to="/privacyPolicy" sx={{ color: '#000' }}>Privacy Policy</StyledRouterLink>
              <StyledRouterLink to="/releases" sx={{ color: '#000' }}>Release Notes</StyledRouterLink>
            </Box>
          </Grid>

          {/* Myfinanza Description */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h5" sx={{ color: '#000', marginBottom: 2, fontSize: '23px' }}>
              Overview
            </Typography>
            <Typography sx={{ color: '#000' }}>
              Finkoda is your trusted partner in achieving financial confidence, offering personalized solutions, expert guidance, and a supportive community to help you navigate your financial journey with simplicity and clarity.
            </Typography>
          </Grid>
        </Grid>

        {/* Copyright */}
        {/* <Box sx={{ marginTop: 4, textAlign: 'center', paddingTop: 2 }}>
          <Typography variant="body2" sx={{ color: '#898d9a' }}>
            © Copyright 2025 finkoda.com
          </Typography>
        </Box> */}
        {/* <Box sx={{ marginTop: 4, paddingTop: 2 }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={7} textAlign="right">
              <Typography variant="body2" sx={{ color: '#898d9a' }}>
                © Copyright 2025 finkoda.com
              </Typography>
            </Grid>
            <Grid xs={3} textAlign="right">
              <Typography variant="body2" sx={{ color: '#898d9a' }}>
                Developed by Fastura Technology
              </Typography>
            </Grid>
          </Grid>
        </Box> */}

        <Box sx={{ marginTop: 4, paddingTop: 2 }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={6} sm={7} textAlign={{ xs: 'left', sm: 'right' }}>
              <Typography variant="body2" sx={{ color: '#000' }}>
                © Copyright 2025 finkoda.com
              </Typography>
            </Grid>
            <Grid item xs={6} sm={5} textAlign={{ xs: 'left', sm: 'right' }}>
              <Typography variant="body2" sx={{ color: '#000' }}>
                Developed by Fastura Technology
              </Typography>
            </Grid>
          </Grid>
        </Box>




      </Container>
    </Box>

  );
};

export default Footer;


